// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3WXi2","notes":"Notes_notes__EHqFC"};